// extracted by mini-css-extract-plugin
export default {"label":"EditDanXuan_label__i28RK","InputOption":"EditDanXuan_InputOption__Skf-Z","OptionCheckbox":"EditDanXuan_OptionCheckbox__2+q5r","RadioGroup":"EditDanXuan_RadioGroup__FBTg0"};